export default __webpack_public_path__ + "static/automatedcompliancecheck-16662dc2cd47104a5949b35113721d7d.svg";